import { useEffect, useState } from "react";

/**
 * Returns a state value that is true after a delay
 * It starts false, and then when show is true, it becomes true after timeoutLength milliseconds
 * @param show
 * @param timeoutLength
 * @returns
 */
export const useTrueAfterDelay = (show, timeoutLength) => {
  const [val, setVal] = useState(false);
  useEffect(() => {
    let timeout;
    if (show) {
      timeout = setTimeout(() => {
        setVal(true);
      }, timeoutLength);
    } else {
      setVal(false);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [show]);
  return val;
};
